/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { AssignmentWithLinks } from '../models/assignment-with-links';
@Injectable({
  providedIn: 'root',
})
class AssignmentsWithLinksService extends __BaseService {
  static readonly AssignmentsWithLinksGetPath = '/assignments-with-links/{assignmentId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Returns the document assignment with links
   * @param params The `AssignmentsWithLinksService.AssignmentsWithLinksGetParams` containing the following parameters:
   *
   * - `assignmentId`: GUID of the assignment
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  AssignmentsWithLinksGetResponse(params: AssignmentsWithLinksService.AssignmentsWithLinksGetParams): __Observable<__StrictHttpResponse<AssignmentWithLinks>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/assignments-with-links/${encodeURIComponent(String(params.assignmentId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AssignmentWithLinks>;
      })
    );
  }
  /**
   * Returns the document assignment with links
   * @param params The `AssignmentsWithLinksService.AssignmentsWithLinksGetParams` containing the following parameters:
   *
   * - `assignmentId`: GUID of the assignment
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  AssignmentsWithLinksGet(params: AssignmentsWithLinksService.AssignmentsWithLinksGetParams): __Observable<AssignmentWithLinks> {
    return this.AssignmentsWithLinksGetResponse(params).pipe(
      __map(_r => _r.body as AssignmentWithLinks)
    );
  }
}

namespace AssignmentsWithLinksService {

  /**
   * Parameters for AssignmentsWithLinksGet
   */
  export interface AssignmentsWithLinksGetParams {

    /**
     * GUID of the assignment
     */
    assignmentId: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;
  }
}

export { AssignmentsWithLinksService }